const h = {
  name: "Customize",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,18.4c0.1-0.1,0.2-0.2,0.3-0.3l0,0l0,0c0.8-0.9,1.3-2.1,1.3-3.4c0-1.4-0.6-2.8-1.5-3.7l0,0
			c-0.1-0.1-0.2-0.2-0.3-0.3c-0.9-0.8-2.1-1.2-3.4-1.2c-1.2,0-2.4,0.4-3.4,1.2c-0.1,0.1-0.2,0.2-0.3,0.3L9.5,23.1v7.4h7.4L29,18.4z
			 M25.3,11.5c0.8,0,1.5,0.3,2.1,0.8l0,0l0,0c0.1,0,0.1,0.1,0.2,0.2c0.6,0.6,0.9,1.4,0.9,2.3c0,0.8-0.3,1.5-0.8,2.1
			c-0.1,0.1-0.1,0.1-0.2,0.2L27,17.6L22.4,13l0.6-0.6c0.1-0.1,0.1-0.1,0.2-0.2l0,0l0,0C23.8,11.8,24.5,11.5,25.3,11.5z M21,14.4
			l4.6,4.6l-9.5,9.5h-4.6v-4.6L21,14.4z"/>
		<path class="st0" d="M0,0h8v3h24V0h8v8h-3v24h3v8h-8v-3H8v3H0v-8h3V8H0V0z M32,35v-3h3V8h-3V5H8v3H5v24h3v3H32z M2,2v4h4V2H2z
			 M34,6h4V2h-4V6z M2,34v4h4v-4H2z M34,38h4v-4h-4V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Customize
};
